export const SET_CHECKLIST = 'SET_CHECKLIST'
export const SET_CHECKLIST_ITEM_CHECKED = 'SET_CHECKLIST_ITEM_CHECKED'
export const RESET_CHECKLIST = 'RESET_CHECKLIST'
export const PENDING_CHECKLIST_ACTION = 'PENDING_CHECKLIST_ACTION'
